<template>
  <el-dialog
    append-to-body
    width="500px"
    title=""
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="el-dialog-title">邀请面试</div>
    </template>
    <el-form
      class="staff-from"
      ref="elFormDom"
      label-width="80px"
      :model="form.data"
      :rules="form.rules"
      hide-required-asterisk
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="岗位" prop="job_id">
            <el-select
              clearable
              v-model="form.data.job_id"
              @change="jobidChange"
            >
              <el-option
                :label="item.title"
                :value="item.id"
                :key="index"
                v-for="(item, index) in activeJob_"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="面试地址" prop="address_id">
            <el-select clearable v-model="form.data.address_id">
              <el-option
                :label="item.working_address + item.address"
                :value="item.id"
                :key="index"
                v-for="(item, index) in addressArr_"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="面试时间" prop="interview_time">
            <el-date-picker
              v-model="form.data.interview_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="submitForm"
          >完成</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import { mixinTable } from "@/mixins/tableCompany.js";
export default {
  mixins: [mixinTable],
  data() {
    return {
      visible: false,
      currentRow: {},
      form: {
        loading: false,
        data: {
          job_id: "",
          interview_time: "", //名称
          address_id: "",
        },
        rules: {
          job_id: [{ required: true, message: "必填项", trigger: "change" }],
          interview_time: [
            { required: true, message: "必填项", trigger: "change" },
          ],
        },
      },
    };
  },
  created() {
    this.getActiveJob();
    this.getaddresslist();
  },
  methods: {
    reset(done) {
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getdetails(row, isToudi = false) {
      this.currentRow = row;
      if (row.job_id) {
        this.form.data.job_id = Number(row.job_id);
        this.jobidChange(row.job_id);
      }
    },
    jobidChange(val) {
      if (val) {
        this.$http
          .get("/company/job/detail", { params: { id: val } })
          .then((res) => {
            if (res.code == 1) {
              this.form.data.address_id = res.data.address_id
                ? res.data.address_id
                : "";
            }
          });
      }
    },
    submitForm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let params = {
            ...this.form.data,
            status: 3, //类型  3:邀面试 4:不合适 5:面试通过 6:面试不通过
            id: this.currentRow.id,
          };
          console.log(params);
          this.form.loading = true;
          this.$http.post("/company/resume/operation", params).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.$emit("update",{id:this.currentRow.id,is_honesty:this.currentRow.is_honesty});
              //此处传递的数据为im聊天发送面试邀请所用
              this.toggle(false);
            } else {
              this.$message.error(res.msg);
            }
            this.form.loading = false;
          });
        }
      });
    },
  },
};
</script>